import { BUTTON_SUBMISSION, MY_ACCOUNT_SETTINGS, STASH, ERROR } from '../constants';

const trackEvent = (settings, { category = BUTTON_SUBMISSION, eventMode } = {}) => {
  const DDOEvent = {
    category: {
      primaryCategory: category
    },
    eventInfo: {
      eventName: MY_ACCOUNT_SETTINGS
    },
    ...(eventMode && { eventMode }),
    myAccount: {
      settings
    }
  };

  digitalData.event = digitalData.event || [];
  digitalData.event.push(DDOEvent);
};

// close-account-page-analytics.ts events
export const closeAccountEvents = () => {
  // setCloseAccountCancelLinkAnalytics
  window.LIFE_CYCLE_EVENT_BUS.on('close-account.cancel-link', () => {
    trackEvent('close account: cancel');
  });

  // setCloseAccountSuccessAnalytics(reason)
  window.LIFE_CYCLE_EVENT_BUS.on('close-account.success', ({ output }) => {
    const reason = output?.reason || '';
    trackEvent(`close account: closed: ${reason}`);
  });

  // setCloseAccountPageLinksAnalytics(linkName)
  window.LIFE_CYCLE_EVENT_BUS.on('close-account.link-click', ({ output }) => {
    const linkName = output?.linkName || '';
    trackEvent(`close account: ${linkName}`, { category: STASH, eventMode: STASH });
  });

  /* 
    setCloseAccountPostPageLoadErrorAnalytics(msg) - distinct from close-account.post-page-load-error
    (closeAccount.js), which pushes to digitalData.page.error[]. This pushes to digitalData.event[],
    like profile.error-event / manage-users.error-event.
  */

  window.LIFE_CYCLE_EVENT_BUS.on('close-account.post-page-error-event', ({ output }) => {
    const message = output?.msg || '';

    const DDOEvent = {
      category: {
        primaryCategory: ERROR
      },
      eventInfo: {
        eventName: 'post page error',
        error: [{
          type: 'error',
          displayType: 'advisory',
          pageSection: 'close account page form',
          code: 'n/a',
          message
        }]
      }
    };

    digitalData.event = digitalData.event || [];
    digitalData.event.push(DDOEvent);
  });
};
